import { render, staticRenderFns } from "./ProductParameters.vue?vue&type=template&id=171aa129&scoped=true"
import script from "./ProductParameters.vue?vue&type=script&lang=js"
export * from "./ProductParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171aa129",
  null
  
)

export default component.exports